export const HOMEPAGE_BANNER_IMAGE_LINK =
  "https://res.cloudinary.com/dskpstidt/image/upload/v1695552592/mbsstock2_jggkoc.jpg";
